import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { visuallyHidden } from "@mui/utils";
import AppBar from "@mui/material/AppBar";
import Button, { buttonClasses } from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import { ToastError, ToastSuccess } from "../../../UiComponents/Toaster/Toast";
import moment from "moment";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import TextField from "@mui/material/TextField";
import DeleteImage from "../../../../src/Resources/Images/delete_common.png";
import TabFilter from "../../Tabs/Tabs";

import { AWS_DIRECTORY_NAME } from "../../../Shared/CommonConstant";
import Loader from "../../../UiComponents/Loader/Loader";
import {
  RemoveRedEyeIcon,
  SearchIcon,
  DeleteIcon,
  DownloadIcon,
  CloudOffIcon,
  RestartAltIcon,
} from "../../../Resources/Icons/icons";
import { CSVLink } from "react-csv";
import {
  GetPolicyList,
  UpdatePolicyList,
  GetPolicyFileById,
  FilterPolicyList,
} from "../../../Service/_index";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker, Radio } from "antd";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import { ButtonGroupContext } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Divider, Stack, Badge } from "@mui/material";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

const { RangePicker } = DatePicker;
function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const getClassName = (data) => {
  // return data.policyNumber ? "file_link" : data.CLEAR ? "button-clear" : data.bounce ? "button-bounce": "button-bounce";
  return data.policyNumber ? "file_link" : "";
};

let globalHeadCells = [];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, viewActionIcon } = props;

  const headCells = [
    {
      id: "issueDate",
      placeMent: "left",
      disablePadding: false,
      label: "Policy Date",
      type: "date",
    },
    {
      id: "policyListName",
      placeMent: "left",
      disablePadding: false,
      label: "Company Name",
    },
    {
      id: "policyNumber",
      placeMent: "left",
      disablePadding: false,
      label: "Policy Number",
      class: getClassName,
      onClick: true,
    },
    {
      id: "customerName",
      placeMent: "left",
      disablePadding: false,
      label: "Customer Name",
    },
    {
      id: "register",
      placeMent: "left",
      disablePadding: false,
      label: "Reg Number",
    },
    {
      id: "chequeNumber",
      placeMent: "left",
      disablePadding: false,
      label: "Cheque Number",
    },
    {
      id: "bankName",
      placeMent: "left",
      disablePadding: false,
      label: "Bank Name",
    },
    {
      id: "email",
      placeMent: "left",
      disablePadding: false,
      label: "User Email",
    },
    {
      id: "policyList",
      placeMent: "left",
      disablePadding: false,
      label: "Branch",
    },
    {
      id: "clear",
      placeMent: "center",
      disablePadding: false,
      label: "CLEAR",
      buttonVariant: "outlined",
      buttonClass: "button-clear",
      buttonLabel: "CLEAR",
      type: "button",
      buttonColor: "success",
      actionType: "clear",
    },
    {
      id: "bounce",
      placeMent: "center",
      disablePadding: false,
      label: "Status",
      buttonVariant: "outlined",
      buttonClass: "button-bounce",
      buttonLabel: "BOUNCE", // make sure the mastertable function key
      type: "button",
      buttonColor: "success",
      actionType: "clear", //it used to pass params
    },
    ...(props.viewActionIcon
      ? [
        {
          id: "action",
          placeMent: "right",
          disablePadding: false,
          label: "RESET",
          type: "button",
          buttonVariant: "outlined",
          buttonColor: "error",
          buttonClass: "button-bounce",
          buttonLabel: "RESET",
          actionType: "Reset",
          icon: <RestartAltIcon />,
        },
      ]
      : []),
  ];
  globalHeadCells = [...headCells];
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return <></>;
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const ChequeStatus = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [policyList, setPolicyList] = React.useState([]);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [resetValue, setResetValue] = useState(1);
  const [openLoader, setOpenLoader] = useState(false);
  const [showAction, setShowAction] = useState(false);
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [tableConfig, setTableConfig] = useState({
    isAction: false,
    isView: false,
    isEdit: false,
    isDelete: false,
    isSearch: false,
    isApprove: false,
  });
  const [FilteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [selectedTab, setSelectedTab] = useState(1);

  const FilterOption = [
    {
      label: "Pending",
      type: "PendingFunction",
      value: 1,
      visibility: "block",
    },
    {
      label: "Cleared",
      type: "CelaredFunction",
      value: 2,
      visibility: "block",
    },
    {
      label: "Bounced",
      type: "BouncedFunction",
      value: 3,
      visibility: "block",
    },
  ];

  const FilterTabFunction = (e) => {
    let data = e?.type;
    if (data === "PendingFunction") {
      PendingFunction();
    } else if (data === "CelaredFunction") {
      CelaredFunction();
    } else if (data === "BouncedFunction") {
      BouncedFunction();
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    // console.log("on Tab change: ", newValue)
    const selectedOption = FilterOption.find(
      (option) => option.value === newValue
    );
    // console.log("selectedOption: ", selectedOption)
    FilterTabFunction(selectedOption);
  };

  const SearchFilteredData = FilteredData.filter((el) => {
    return `${el?.policyListName},${el?.policyNumber},${el?.customerName},${el?.register},${el?.chequeNumber},${el.bankName},${el.email},${el.policyList}`
      .toLowerCase()
      .includes(searchText.trim().toLowerCase());
  });

  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(policyList), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filter, policyList]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - policyList.length) : 0;

  const GetData = () => {
    // Changes by Arun
    GetPolicyList({ chequeStatus: true }).then((res) => {
      const data = res.data.map((e) => {
        return {
          ...e,
          formateData: moment(e.issueDate).format("DD/MM/YYYY"),
        };
      });
      const FilterData = data.filter(
        (res) =>
          res.paymentMode === "Cheque" &&
          res.status === "chequePending"
      );
      setPolicyList(FilterData);
    });
  };

  React.useEffect(() => {
    GetData();
  }, []);

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el.policyNumber},${el.companyId?.shortName},${el.customerName},${el.registrationNumber},${el.chequeNumber},${el.bankName},${el.email},${el.remarks}`
              .toLowerCase()
              .includes(target.value.toLowerCase())
          );
      },
    });
    setPage(0);
  };

  const OpenPolicyFile = (row) => {
    setOpenLoader(true);
    GetPolicyFileById(row?._id)
      .then((res) => {
        const pdfUrl = res?.data?.policyFile?.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        setOpenLoader(false);
        // Changes by Arun
        const blobData = base64toBlob(pdfUrl, "application/pdf");
        const blobUrl = URL.createObjectURL(blobData);
        setOpenLoader(false);
        const pdfWindow = window.open("", "_blank");
        pdfWindow?.document?.write(
          // `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
          `<embed src="${blobUrl}" width="100%" height="100%" />`
        );
        // const pdfWindow = window.open("", "_blank");
        // pdfWindow?.document?.write(`<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`);
      });
  };

  // Changes by Arun
  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  const PendingFunction = () => {
    setOpenLoader(true);
    setShowAction(false);
    FilterPolicyList({
      startDate: selectedStartDate,
      endDate: selectedEndDate,
      isChequeStatus: true,
    })
      .then((res) => {
        setOpenLoader(false);
        const data = res.data.map((e) => {
          return {
            ...e,
            formateData: moment(e.issueDate).format("DD/MM/YYYY"),
          };
        });
        const FilterPolicy = data.filter(
          (res) =>
            res.status === "chequePending" &&
            res.paymentMode === "Cheque"
        );
        setPolicyList(FilterPolicy);
        setPage(0);
      })
      .catch((err) => {
        setOpenLoader(false);
        console.log("err");
      });
  };

  const CelaredFunction = () => {
    // Changes by Arun
    if (!selectedStartDate || !selectedEndDate) {
      setPolicyList([]);
      setShowFilter(true);
      ToastError("Please select date range");
      return true;
    }
    setOpenLoader(true);
    setShowAction(true);
    FilterPolicyList({
      startDate: selectedStartDate,
      endDate: selectedEndDate,
      isChequeStatus: true,
    })
      .then((res) => {
        setOpenLoader(false);
        const data = res.data.map((e) => {
          return {
            ...e,
            formateData: moment(e.issueDate).format("DD/MM/YYYY"),
          };
        });
        const FilterPolicy = data.filter(
          (res) =>
            // res.status === "verifyPending" &&
            res.paymentMode === "Cheque" && res.chequeStatus === "Cleared"
        );
        setPolicyList(FilterPolicy);
        setPage(0);
      })
      .catch((err) => {
        console.log("err");
      });
  };

  const BouncedFunction = () => {
    // Changes by Arun
    if (!selectedStartDate || !selectedEndDate) {
      setPolicyList([]);
      setShowFilter(true);
      ToastError("Please select date range");
      return true;
    }

    setShowAction(true);
    setOpenLoader(true);
    FilterPolicyList({
      startDate: selectedStartDate,
      endDate: selectedEndDate,
      isChequeStatus: true,
    })
      .then((res) => {
        setOpenLoader(false);
        const data = res.data.map((e) => {
          return {
            ...e,
            formateData: moment(e.issueDate).format("DD/MM/YYYY"),
          };
        });
        const FilterPolicy = data.filter(
          (res) =>
            // res.status === "rejectedPolicy" &&
            res.paymentMode === "Cheque" && res.chequeStatus === "Bounced"
        );
        setPolicyList(FilterPolicy);
        setPage(0);
      })
      .catch((err) => {
        console.log("err");
      });
  };

  const header = [
    { label: "Policy Date", key: "formateData" },
    { label: "Company Name", key: "companyId.shortName" },
    { label: "Policy Number", key: "policyNumber" },
    { label: "Customer Name", key: "customerName" },
    { label: "Mobile", key: "userId.mobileNumber" },
    { label: "Payment Mode", key: "paymentMode" },
    { label: "Reg Number", key: "registrationNumber" },
    { label: "User Email", key: "userId.email" },
  ];
  const csvFile = {
    filename: "Cheque Status Data",
    headers: header,
    data: policyList,
  };
  const ResetFunction = (row) => {
    let stringWithQuotes = row?.policyNumber;
    let stringWithoutQuotes = stringWithQuotes.replace(/'/g, "");
    row.policyNumber = stringWithoutQuotes;
    row.status = "chequePending";
    row.rejectedReason = "";
    row.chequeStatus = "";
    row.issueDate = row.unformattedIssuDate;
    UpdatePolicyList(row?._id, row)
      .then((res) => {
        setOpenLoader(false);
        PendingFunction();
        setShowAction(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    // console.log("from use State: ", visibleRows)
    setFilteredData(
      policyList.map((data) => ({
        _id: data._id,
        issueDate: data.issueDate,
        policyListName: data.companyId?.shortName,
        policyNumber: data.policyNumber,
        bankName: data.bankName,
        customerName: data.customerName,
        register: data.registrationNumber,
        chequeNumber: data.chequeNumber,
        bankName: data.bankName,
        email: data.userId?.email,
        policyList: data.remarks,
        CLEAR: "CLEAR",
        bounce: "BOUNCE",
        chequeStatus: data.chequeStatus,
        rejectedReason: data.rejectedReason,
        Status: data.status || "BOUNCE",
        data: data,
      }))
    );
  }, [policyList]);

  const ChequeMangeFunction = (data, key) => {
    setOpenLoader(true);
    if (key === "Clear") {
      data.status = "verifyPending";
      data.rejectedReason = "Suspend";
      data.chequeStatus = "Cleared";
      data.status === "approvedPolicy"
        ? (data.rejectedReason = "Approved")
        : (data.rejectedReason = "Suspend");
    } else {
      data.status = "rejectedPolicy";
      data.rejectedReason = "Cheque Bounced";
      data.chequeStatus = "Bounced";
    }
    let stringWithQuotes = data?.policyNumber;
    let stringWithoutQuotes = stringWithQuotes.replace(/'/g, "");
    data.policyNumber = stringWithoutQuotes;
    data.userId = data?.userId?._id;
    data.companyId = data?.companyId?._id;
    data.bookingCodeId = data?.bookingCodeId?._id;
    data.productId = data?.productId?._id;
    data.policyTypeId = data?.policyTypeId?._id;
    data.subBookingCodeId = data?.subBookingCodeId?._id;
    data.subProductId = data?.subProductId?._id;
    UpdatePolicyList(data?._id, data)
      .then((res) => {
        setOpenLoader(false);

        PendingFunction();
      })
      .catch((err) => {
        console.log(err);
        ToastError("Something Went error");
      });
  };
  const implementCond = (cell) => {
    return cell.map((obj) =>
      obj.id === "clear"
        ? {
          ...obj,
          condition: (row) => row.Status === "chequePending", // Only show when condition is met
          fallbackText: (row) => row?.chequeStatus,
        }
        : obj.id === "bounce"
          ? {
            ...obj,
            condition: (row) => row.Status === "chequePending",
            fallbackText: (row) => row?.rejectedReason,
          }
          : obj.id === "action"
            ? {
              ...obj,
              condition: () => showAction, // Only show when showAction is true
              fallbackText: null, // No fallback text
            }
            : obj
    );
  };

  const handleClearAllState = () => {
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    // Reset to pending tab and fetch data without filters
    setSelectedTab(1);
    PendingFunction();
  };

  const handleClearSingleFilter = (filterId) => {
    if (filterId === 1) {
      setSelectedStartDate(null);
      setSelectedEndDate(null);
    }
    // Fetch data without the cleared filter
    handleTabChange("", selectedTab);
  };

  const handleSaveAllFilter = () => {
    // console.log(selectedTab, selectedUser, ".../...");
    // console.log("function calling...");
    // FilterData()
    handleTabChange("", selectedTab);
  };

  const filterBoxData = [
    {
      id: 1,
      label: "Select Date",
      setDate: (e) => {
        setSelectedStartDate(e ? e[0] : null);
        setSelectedEndDate(e ? e[1] : null);
      },
      type: "noDefaultDate",
    },
  ];

  const activeFiltersCount = [
    selectedStartDate && selectedEndDate ? 1 : 0,
  ].filter(Boolean).length;

  return (
    <>
      <EnhancedTableHead
        order={order}
        orderBy={orderBy}
        onRequestSort={handleRequestSort}
        rowCount={policyList?.length}
        viewActionIcon={showAction}
      />

      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
              >
                <Grid item xs={12} sm={6} md={6}>
                  <Typography className="Master_Card_Tittle">
                    Cheque Status
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                  >
                    <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <Badge
                            badgeContent={activeFiltersCount}
                            color="error"
                            sx={{
                              "& .MuiBadge-badge": {
                                right: 5,
                                top: 3,
                                width: "14px",
                                height: "14px",
                                minWidth: "14px",
                                borderRadius: "50%",
                                fontSize: "8.91px",
                                fontWeight: "600",
                                backgroundColor: "#E50000",
                                color: "#fff",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <FilterListIcon sx={{ marginRight: "1.5px" }} />
                          </Badge>
                        }
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        Filters
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <CloudDownloadOutlinedIcon
                            sx={{
                              color: "#344054",
                            }}
                          />
                        }
                      >
                        <CSVLink
                          style={{ textDecoration: "none", color: "inherit" }}
                          {...csvFile}
                        >
                          Export
                        </CSVLink>
                      </Button>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>

              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={true}
                    sx={{
                      "& .filter-box-container": {
                        boxShadow: "none",
                        border: "none",
                        p: 0,
                      },
                      "& .MuiPaper-root": {
                        boxShadow: "none",
                        border: "none",
                        p: 0,
                      },
                    }}
                  />
                </Box>
              )}

              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>

              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
                className="Master_Card_Sub_Container"
              >
                <TabFilter
                  options={FilterOption}
                  selectedTab={selectedTab}
                  onTabChange={handleTabChange}
                />
                <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      setPage(0);
                    }}
                    disableUnderline={true}
                    placeholder="Search "
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={tableConfig}
                data={SearchFilteredData}
                columns={implementCond(globalHeadCells)}
                handleOnClickBehaviour={OpenPolicyFile}
                handleButton={{
                  RESET: ResetFunction,
                  CLEAR: ChequeMangeFunction,
                  BOUNCE: ChequeMangeFunction,
                }}
                tableTotalCount={filter.fn(policyList)?.length || 0}
                loading={openLoader}
              />
            </Grid>
          </Box>
        </Box>
      </div>

      <Drawer
        open={openDrawer}
        sx={{
          zIndex: 100,
        }}
        anchor="right"
        PaperProps={{
          sx: { width: { xs: "100%", sm: "25%" } },
        }}
      ></Drawer>
      {/* <Loader open={openLoader} /> */}

      <ConfirmBox
        open={openConfirmBox}
        title={"Delete"}
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton={"Delete"}
        setOpenConfirmBox={setOpenConfirmBox}
        icon={<DeleteIcon />}
      />
    </>
  );
};
export default ChequeStatus;
